var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconArchive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_Unarchive-Project-16x16",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3431606,9.22045686 C10.6453296,9.22045686 10.9249094,9.50453339 10.9249094,9.82127061 C10.9249094,10.1380078 10.6453296,10.3674638 10.3431606,10.3674638 L1.7183451,10.3674638 L2.66934833,11.6947521 C2.88300342,11.9187303 2.86706237,12.3053851 2.66934833,12.50003 C2.47163428,12.694675 2.08176348,12.694675 1.86809772,12.470708 L0.16023001,10.1992712 C-0.0534100035,9.97530881 -0.0534100035,9.61221771 0.16023001,9.38825531 L1.86809772,7.17553675 C2.08176348,6.95156971 2.50790238,6.95156971 2.66934833,7.12078243 C2.83079428,7.28999514 2.97349599,7.66180157 2.73289257,7.91403018 L1.7183451,9.22045686 L10.3431606,9.22045686 Z",
    id: "Path",
    fill: "#3B7FF5",
    fillRule: "nonzero",
    transform: "translate(5.462455, 9.821271) scale(1, -1) rotate(-180.000000) translate(-5.462455, -9.821271) "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-53",
    fill: "#3B7FF5",
    points: "2 4.99576928 16 4.99576928 16 4.00423072 2 4.00423072"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,4.04635559 L4,3 C4,2.44771525 4.44771525,2 5,2 L12,2 C12.5522847,2 13,2.44771525 13,3 L13,4.04635559 L13,4.04635559 L11.9769119,4.00423072 L11.9769119,3.24331424 C11.9769119,3.07762882 11.8425973,2.94331424 11.6769119,2.94331424 L5.31426342,2.94331424 C5.148578,2.94331424 5.01426342,3.07762882 5.01426342,3.24331424 L5.01426342,4.04635559 L5.01426342,4.04635559 L4,4.04635559 Z",
    id: "Path-54",
    fill: "#3B7FF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,1 L2,7.8135817 C2,8.06848235 2.20663781,8.27512016 2.46153846,8.27512016 C2.71643912,8.27512016 2.92307692,8.06848235 2.92307692,7.8135817 L2.92307692,1.4 C2.92307692,1.1790861 3.10216302,1 3.32307692,1 L7.42663039,1 L11.5883834,1 C11.8479819,1 12.0974064,1.10095222 12.2839244,1.28151361 L14.970308,3.88210565 C15.048147,3.95745878 15.0920916,4.06116278 15.0920916,4.16950021 L15.0920916,13.6 C15.0920916,13.8209139 14.9130055,14 14.6920916,14 L3.32307692,14 C3.10216302,14 2.92307692,13.8209139 2.92307692,13.6 L2.92307692,11.9576877 C2.92307692,11.702787 2.71643912,11.4961492 2.46153846,11.4961492 C2.20663781,11.4961492 2,11.702787 2,11.9576877 L2,14 C2,14.5522847 2.44771525,15 3,15 L15,15 C15.5522847,15 16,14.5522847 16,14 L16,3.81880679 C16,3.55023961 15.891972,3.29296051 15.7002398,3.10489908 L12.8264131,0.286092298 C12.6394628,0.102721183 12.3880423,1.7493359e-15 12.1261733,0 L7.75596026,0 L3,0 C2.44771525,1.01453063e-16 2,0.44771525 2,1 Z",
    id: "Path-52",
    fill: "#3B7FF5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArchive);
export default __webpack_public_path__ + "static/media/icon-archive.9344643df70a7a23f7fb7d4ccfaa1742.svg";
export { ForwardRef as ReactComponent };